import { IcpScope } from 'mormaii-web-presentation/icp'
import type { ViewFactory } from 'wdc-cube-solid'

import { IcpView } from './v-icp'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(IcpScope, IcpView)
}

export { IcpView }
